import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-926248c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-legend" }
const _hoisted_2 = {
  key: 0,
  class: "point"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "水库", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "物联", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "一体化", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "国控", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "市控", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "区控", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "饮用水源地", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "河道视频监控", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "工业企业", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "水产养殖场", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "污水处理厂", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "畜禽养殖场", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "水文站", -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<p style=\"width:160px;\" data-v-926248c0></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>Ⅰ类</span><span class=\"color\" style=\"background:#5bcffb;\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>Ⅱ类</span><span class=\"color\" style=\"background:#2288ff;\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>Ⅲ类</span><span class=\"color\" style=\"background:#0efd85;\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>Ⅳ类</span><span class=\"color\" style=\"background:#fcd617;\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>Ⅴ类</span><span class=\"color\" style=\"background:#ff9700;\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>劣Ⅴ类</span><span class=\"color\" style=\"background:#f81313;\" data-v-926248c0></span></p>", 7)
const _hoisted_23 = { class: "point" }
const _hoisted_24 = {
  key: 0,
  class: "d-f mb20 ml30"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "高：897"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt50" }, "低：193")
], -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<p data-v-926248c0><span class=\"text\" data-v-926248c0>休耕</span><span class=\"color\" style=\"background:rgb(214,217,121);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>三季作物</span><span class=\"color\" style=\"background:rgb(115,189,145);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>单季玉米</span><span class=\"color\" style=\"background:rgb(189,219,164);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>单季水稻</span><span class=\"color\" style=\"background:rgb(156,212,121);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>单季其他</span><span class=\"color\" style=\"background:rgb(156,161,114);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>其他双季作物</span><span class=\"color\" style=\"background:rgb(149,205,207);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>水稻+玉米</span><span class=\"color\" style=\"background:rgb(87,156,92);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>双季水稻</span><span class=\"color\" style=\"background:rgb(95,152,153);\" data-v-926248c0></span></p>", 8)
const _hoisted_37 = [
  _hoisted_29
]
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<p data-v-926248c0><span class=\"text\" data-v-926248c0>耕地</span><span class=\"color\" style=\"background:rgb(255,251,177);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>林地</span><span class=\"color\" style=\"background:rgb(49,173,105);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>草地</span><span class=\"color\" style=\"background:rgb(154,206,127);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>灌木地</span><span class=\"color\" style=\"background:rgb(231,204,226);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>水源地</span><span class=\"color\" style=\"background:rgb(163,214,245);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>住宅区</span><span class=\"color\" style=\"background:rgb(220,100,120);\" data-v-926248c0></span></p>", 6)
const _hoisted_45 = [
  _hoisted_39
]
const _hoisted_46 = { key: 3 }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<p data-v-926248c0><span class=\"text\" data-v-926248c0>江河</span><span class=\"color\" style=\"background:rgb(33,130,146);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>黄壤</span><span class=\"color\" style=\"background:rgb(102,163,158);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>紫色土</span><span class=\"color\" style=\"background:rgb(187,128,70);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>水稻土</span><span class=\"color\" style=\"background:rgb(224,237,183);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>中性紫色土</span><span class=\"color\" style=\"background:rgb(214,173,111);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>石灰性紫色土</span><span class=\"color\" style=\"background:rgb(155,86,31);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>黄色石灰土</span><span class=\"color\" style=\"background:rgb(242,228,165);\" data-v-926248c0></span></p><p data-v-926248c0><span class=\"text\" data-v-926248c0>漂洗水稻土</span><span class=\"color\" style=\"background:rgb(161,200,173);\" data-v-926248c0></span></p>", 8)
const _hoisted_55 = [
  _hoisted_47
]

import { ref, onMounted, watch } from 'vue'
import { useRouter, onBeforeRouteUpdate } from 'vue-router'
import mapService from '@/utils/mapServices.js'
import Bus from '@/config/Bus'
import pinia from '@/store/index'
import { useMainStore } from '@/store/main'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapLegend',
  setup(__props) {

const mainStore = useMainStore(pinia)
const router = useRouter()

const legends = ref({})

watch(
  () => router.currentRoute.value,
  (newValue, oldValue) => {
    legends.value = {}
  }
)

onMounted(() => {
  Bus.on('changeMapLegenf', (data) => {
    legends.value[data.type] = data.state
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(mainStore).legendType === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _hoisted_3,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/水库.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_4,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/物联.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_5,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/一体化_1类.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_6,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/国控_1类.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_7,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/市控_1类.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_8,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/区控_1类.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_9,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/饮用水源地.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_10,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/视频监控.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_11,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/工业企业.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_12,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/水产养殖场.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_13,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/污水厂.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_14,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/畜禽养殖场.png') + ')')
            }, null, 4)
          ]),
          _createElementVNode("p", null, [
            _hoisted_15,
            _createElementVNode("span", {
              class: "icon",
              style: _normalizeStyle('background-image: url(' + require('@/assets/img/map/水文站.png') + ')')
            }, null, 4)
          ]),
          _hoisted_16
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      (_unref(mainStore).legendType === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
        : _createCommentVNode("", true),
      (_unref(mainStore).legendType === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_37))
        : _createCommentVNode("", true),
      (_unref(mainStore).legendType === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_45))
        : _createCommentVNode("", true),
      (_unref(mainStore).legendType === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_55))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})